<template>
  <v-app class="custom__bg mt-1">
    <v-container>
      <v-row>
        <!-- Left Sidebar (Profile) -->
        <v-col cols="12" md="3" lg="3">
          <v-col cols="12" class="py-1">
            <v-card class="text-center premium-card animate-fadeInUp" max-width="300">
              <v-card-text>
                <v-avatar size="70" class="elevation-2" style="border: 2px solid #f69227">
                  <img :src="$root.store.getUserAvatar()" alt="Profile Picture" />
                </v-avatar>
                <div class="mt-3 black--text">
                  <h2 style="font-size: 17px; font-weight: 700">{{ $root.storeState.currentUser.name || 'Student' }}</h2>
                  <p style="font-size: 12px; color: #707070">{{ $root.storeState.currentUser.school || 'Not specified' }}</p>
                </div>
                
                <div class="mt-4">
                  <v-btn
                    rounded block height="44" color="#f69227"
                    class="white--text text-capitalize hover-scale"
                    elevation="2"
                    to="/settings"
                  >
                    <v-icon left small>mdi-account-edit</v-icon>
                    Update Profile
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12" class="mt-2 hidden-sm-and-down">
            <v-card class="premium-card text-center pa-4" style="background: linear-gradient(135deg, #f0f2f5 0%, #e0e5ec 100%)">
              <v-icon size="48" color="grey lighten-1">mdi-advertisements</v-icon>
              <h4 class="mt-2 grey--text text--darken-1">Advertisement</h4>
            </v-card>
          </v-col>
        </v-col>

        <!-- Main Content (Yearbooks) -->
        <v-col cols="12" md="9" lg="9">
          <v-card class="premium-card pa-5 min-h-600 animate-fadeInUp delay-2 bg-transparent" flat>
            <div class="d-flex align-center justify-space-between mb-6 px-2">
              <div>
                <h2 style="font-size: 24px; font-weight: 700; color: #333">My Yearbooks</h2>
                <p class="grey--text text--darken-1 mb-0" style="font-size: 14px">Connect with your current and former classmates</p>
              </div>
              <v-btn icon color="#f69227" class="elevation-1 bg-white hover-scale"><v-icon>mdi-magnify</v-icon></v-btn>
            </div>

            <v-row class="mt-8">
              <v-col cols="12" sm="6" md="4" v-for="(item, index) in yearbooks" :key="index" class="mb-8">
                <v-card class="premium-card-elevated text-center hover-scale pt-8 pb-4 px-4 fill-height d-flex flex-column" style="overflow: visible; position: relative; margin-top: 30px">
                  <!-- Avatar overlaps the top edge -->
                  <div style="position: absolute; top: -45px; left: 50%; transform: translateX(-50%);">
                    <v-avatar size="90" class="elevation-3" style="border: 4px solid white; background-color: white">
                      <v-img :src="item.logo" contain class="pa-2"></v-img>
                    </v-avatar>
                  </div>
                  
                  <div class="flex-grow-1 mt-4">
                    <h3 style="font-size: 16px; font-weight: 700; color: #333; line-height: 1.3" class="mb-1">{{ item.school }}</h3>
                    <p class="grey--text text--darken-1 mb-2" style="font-size: 13px"><v-icon x-small class="mr-1">mdi-map-marker</v-icon>{{ item.city }}</p>
                    
                    <v-chip small color="#f0f2f5" text-color="#555" class="font-weight-bold mb-4 px-3" style="font-size: 12px">
                      {{ item.department }}
                    </v-chip>
                  </div>
                  
                  <v-divider class="mb-3"></v-divider>
                  
                  <div>
                    <v-btn 
                      rounded 
                      block 
                      color="#f5f5f5" 
                      class="text-capitalize grey--text text--darken-3 font-weight-bold hover-glow-orange"
                      elevation="0"
                      @click="goClass(item.id)"
                    >
                      Class of {{ item.year }}
                      <v-icon right small color="#f69227">mdi-arrow-right</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
              
              <!-- Add New Yearbook Card -->
              <v-col cols="12" sm="6" md="4" class="mb-8">
                <v-card class="premium-card text-center hover-scale pt-8 pb-4 px-4 fill-height d-flex flex-column justify-center align-center" style="border: 2px dashed #e0e0e0; background-color: transparent; margin-top: 30px; min-height: 220px" @click="$router.push('/settings')">
                  <v-icon size="48" color="grey lighten-1" class="mb-2">mdi-plus-circle-outline</v-icon>
                  <h3 style="font-size: 16px; font-weight: 600; color: #777">Add School</h3>
                  <p class="grey--text caption mt-1 px-4">Update your profile to add more schools to your yearbook.</p>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    yearbooks: [
      {
        id: "1",
        school: "Ahmadu Bello University",
        city: "Zaria, Kaduna",
        department: "Accounting",
        year: "2020",
        logo: "https://ui-avatars.com/api/?name=ABU&background=0D8ABC&color=fff&size=128"
      },
      {
        id: "2",
        school: "Bayero University, Kano",
        city: "Kano, Kano State",
        department: "Computer Science",
        year: "2023",
        logo: "https://ui-avatars.com/api/?name=BUK&background=4CAF50&color=fff&size=128"
      },
      {
        id: "3",
        school: "University of Lagos",
        city: "Lagos, Lagos State",
        department: "Law",
        year: "2019",
        logo: "https://ui-avatars.com/api/?name=UNILAG&background=B71C1C&color=fff&size=128"
      },
      {
        id: "4",
        school: "Obafemi Awolowo University",
        city: "Ile-Ife, Osun State",
        department: "Medicine",
        year: "2022",
        logo: "https://ui-avatars.com/api/?name=OAU&background=F57F17&color=fff&size=128"
      },
      {
        id: "5",
        school: "University of Nigeria, Nsukka",
        city: "Nsukka, Enugu State",
        department: "Engineering",
        year: "2018",
        logo: "https://ui-avatars.com/api/?name=UNN&background=1B5E20&color=fff&size=128"
      },
      {
        id: "6",
        school: "Government College Ibadan",
        city: "Ibadan, Oyo State",
        department: "Science",
        year: "2013",
        logo: "https://ui-avatars.com/api/?name=GCI&background=3F51B5&color=fff&size=128"
      },
    ],
  }),
  methods: {
    goClass() {
      this.$root.showSnackbar("Opening yearbook class...", "#f69227", "mdi-book-open-page-variant");
      // this.$router.push('/yearbook/' + id)
    }
  }
};
</script>

<style scoped>
.custom__bg {
  background: #f5f5f5;
  min-height: 100vh;
}
.min-h-600 {
  min-height: 600px;
}
.bg-transparent {
  background-color: transparent !important;
}
.bg-white {
  background-color: white !important;
}
</style>
